import * as React from "react"

export default function LogoTesla() {
  return (
    <svg
      width={500}
      height={65}
      viewBox="0 0 500 65"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M112.922 0h74.785c-1.402 5.732-6.41 11.66-13.155 13h-48.468c-6.68-1.34-11.762-7.268-13.162-13zm13.165 64.939c-6.683-1.343-11.768-7.255-13.165-12.997h74.785c-1.402 5.742-6.41 11.654-13.155 13h-48.468l.003-.003zm0-26.32c-6.683-1.328-11.768-7.255-13.165-12.987h74.785c-1.402 5.732-6.41 11.66-13.155 12.987h-48.468.003zM500 .049v.01c-1.41 5.728-6.423 11.653-13.156 12.98H438.37c-6.674-1.33-11.768-7.258-13.162-12.99H500zM0 .147V.024h81.964v.123c-1.437 5.677-6.255 11.158-13.072 12.917H48.465l-1.15.41V64.8H34.563V13.473l-1.034-.41H13.13C6.38 11.606 1.456 5.824 0 .148zM343.547.083l-.03 52.101h56.544c-1.313 5.426-4.717 10.075-11.075 12.764h-58.112V.113l12.673-.03zm-62.156 12.773h-44.782V25.67h58.176v39.265H224.05L220.36 65c3.035-6.331 9.086-11.115 16.25-13.103l45.661-.04V38.41h-58.22V.095h71.129c-1.382 5.683-7.055 10.806-13.788 12.758v.003zm145.771 52.08V25.723l71.094.068v39.145h-12.598v-26.1H439.77v26.1h-12.608z"
        fill="#404040"
        fillRule="evenodd"
      />
    </svg>
  )
}
